import {
	ModuleContextMenuData,
	SelectedCreatorProductModule,
	SelectedSlot,
} from '@/types/creator';
import { SerializedModulesManager } from './ModuleManager';
import { UUID } from '@/types/types';

export enum UserDataProp {
	IS_CONNECTING_SLOT = 'is_connecting_slot',
	SLOT_TYPE = 'slot_type',
	IS_COLLECTION = 'is_collection',
	IS_SOFA_MODULE = 'is_sofa_module',
	SOFA_MODULE_ID = 'sofa_module_id',
	PREDEFINED_MATERIAL = 'predefined_material',
}

export enum ThreeEvent {
	SLOT_SELECTION = 'slot_selection',
	MODULE_SELECTION = 'module_selection',
	DESELECT_ALL = 'deselect_all',
	UPDATE_CAMERA_DISTANCE = 'update_camera_distance',
	SET_CREATOR_PRODUCT_MODULES_ORDER = 'set_creator_product_modules_order',
	CONTEXT_MENU = 'context_menu',
}

export type ThreeEvents = {
	[ThreeEvent.SLOT_SELECTION]: SelectedSlot | null;
	[ThreeEvent.MODULE_SELECTION]: Pick<
		SelectedCreatorProductModule,
		'id' | 'deleteable'
	>;
	[ThreeEvent.DESELECT_ALL]: void;
	[ThreeEvent.UPDATE_CAMERA_DISTANCE]: number;
	[ThreeEvent.SET_CREATOR_PRODUCT_MODULES_ORDER]: UUID[];
	[ThreeEvent.CONTEXT_MENU]: ModuleContextMenuData;
};

export type SerializedRenderer = {
	modulesManager: SerializedModulesManager;
};
